import { post } from "jquery";
import axios from "../api/axios";
import config from '../config/configJS';

export function getEnvironmentsforUser() { 
    return postData('GetDocsEnv', {})
        .then((data) => data.Data);
}

export function getAllEnvironments() {
    return postData('GetAllDocsEnv', {})
    .then((data) => data.Data);
}

export function getFilesForEnvironment(id) {
    return postData('GetDocsEnvById', { "Id": id })
        .then((data) => data.Data.Files); 
}

export function getEnvironmentById(id) {
    return postData('GetDocsEnvWithTeamsById', { "Id": id })
        .then((data) => data.Data); 
}

export function deleteEnvironment(id) {
    return postData('DeleteDocsEnv', {
        "Id": id
    }).then((data => data.Data));
}

export function createEnvironment(env) {
    return postData('CreateDocsEnv', {
        "Name": env.Name, 
        "FolderName": env.FolderName, 
        "RoleId": env.RoleId,
        "TeamIds": env.TeamIds
    }).then((data) => data);
}

export function updateEnvironment(env) {
    return postData('UpdateDocsEnv', {
        "Id": env.id,
        "Name" : env.name,
        "TeamIds" : env.teamIds
    }).then((data) => data.Data);
}

export function deleteFiles(ids) {
    return postData('FilesToBeDeleted', {
        "ids" : [ids]
    }).then((data) => data.Data);
}

export function getTeams() {
    return postData('GetTeams', {})
    .then((data) => data.Data);
}

function postData(intent, data) { 
    var promise = new Promise(function (resolve, reject) { 
      axios
        .post(config.endPoint + '/api/millai/prompt', 
            JSON.stringify({ Intent: intent, data: data }), {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            withCredentials: true,
        })
        .then((response) => {       
            let obj = JSON.parse(response.data);
            resolve(obj);
        })
        .catch((error) => {
            console.log(error);
            reject(error);
        });
    });

    return promise;
}


